import axios from 'axios';
import { KnowledgeTestSummary } from 'types/api/KnowledgeTest';
import { KnowledgeTestAttempt } from 'types/api/TestAttempt';

export function getKnowledgeTestAttempt(testAttemptId: number) {
  return axios.get<KnowledgeTestAttempt>(
    `/api/v2/test_attempts/${testAttemptId}`
  );
}

export function setCurrentQuestion(id: number, questionId: number) {
  return axios.post<KnowledgeTestAttempt>(
    `/api/v2/test_attempts/${id}/set_current_question`,
    {
      current_question_id: questionId
    }
  );
}

export function getKnowledgeTestSummary(testAttemptId: number) {
  return axios.get<KnowledgeTestSummary>(
    `/api/v2/knowledge_tests/${testAttemptId}`
  );
}
